var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShrink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 492 492",
    style: {
      enableBackground: "new 0 0 492 492"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.8,377.8L64.1,474c-3.5,4.9-2.3,11.7,2.6,15.2c4.9,3.5,11.7,2.3,15.1-2.6l79.8-113.4 c5.1-7.2-0.1-17.1-8.9-17.1H90l59.7-84.8l7.9,21.9c2,5.6,8.3,8.6,13.9,6.5c5.6-2,8.6-8.3,6.5-13.9l-15-41.5 c-3-8.3-14.1-9.7-19.1-2.6l-83.8,119c-5.1,7.2,0.1,17.1,8.9,17.1H131.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.6,265.6c-5.9,0.9-11.5-3.3-12.3-9.2c-0.9-5.9,3.3-11.5,9.2-12.3l49.1-7.1c9.4-1.4,15.9,9.2,10.5,17 l-83,119.4c-3.4,4.9-10.2,6.1-15.1,2.7c-4.9-3.4-6.1-10.2-2.7-15.1l68.7-98.8L105.6,265.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M301.6,67l82.1,392.4c1.2,5.9,7,9.6,12.9,8.4c5.9-1.2,9.6-7,8.4-12.9L311.8,9.5C309.4-2.2,292.7-2,290.5,9.7 l-85.4,445.4c-1.1,5.9,2.7,11.6,8.6,12.7c5.9,1.1,11.6-2.7,12.7-8.6L301.6,67z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.6,345H423c6,0,10.9-4.9,10.9-10.9c0-6-4.9-10.9-10.9-10.9H181.6c-6,0-10.9,4.9-10.9,10.9 C170.8,340.1,175.6,345,181.6,345z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M239,196.7h124.3c7.2,0,13-5.8,13-13c0-7.2-5.8-13-13-13H239c-7.2,0-13,5.8-13,13 C226,190.8,231.8,196.7,239,196.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208,272.6h186.4c6,0,10.9-4.9,10.9-10.9c0-6-4.9-10.9-10.9-10.9H208c-6,0-10.9,4.9-10.9,10.9 C197.1,267.8,202,272.6,208,272.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShrink);
export default __webpack_public_path__ + "static/media/Shrink.31a91b43.svg";
export { ForwardRef as ReactComponent };